<template>
  <div>
    <mdb-modal
      removeBackdrop
      size="sm"
      :show="modalShow"
      @close="handleClose"
      info
    >
      <mdb-modal-header>
        <mdb-modal-title>{{ $t("notification_modal_title") }}</mdb-modal-title>
      </mdb-modal-header>
      <mdb-modal-body>
        {{ $t("notification_modal_description") }}
        <DateTimePicker
          :date-time="notificationItem.due"
          v-on:datetime-changed="setNotificationDue"
        />
        <mdb-input
              :label="$t('notification_modal_notification_title')"
              type="text"
              v-model="notificationItem.title"
            />
        <NotificationRadiusSelection v-on:notification_radius="setNotificationRadius" />
        <UnionMemberSelection v-on:unionmemberid="setUnionMemberId" />
      </mdb-modal-body>
      <mdb-modal-footer>
        <mdb-btn @click="handleOk" color="primary" size="sm">{{
          $t("notification_modal_save")
        }}</mdb-btn>
      </mdb-modal-footer>
    </mdb-modal>
  </div>
</template>

<script>
import {
  mdbModal,
  mdbModalHeader,
  mdbModalTitle,
  mdbModalBody,
  mdbModalFooter,
  mdbBtn,
  mdbInput
} from "mdbvue";
import DateTimePicker from "./DateTimePicker.vue";
import UnionMemberSelection from "./UnionMemberSelection.vue";
import NotificationRadiusSelection from "./NotificationRadiusSelection.vue";
export default {
  name: "NotificationModal",
  props: {
    modalShow: {
      type: Boolean,
      default: false
    }
  },
  components: {
    mdbModal,
    mdbModalHeader,
    mdbModalTitle,
    mdbModalBody,
    mdbModalFooter,
    mdbBtn,
    mdbInput,
    DateTimePicker,
    UnionMemberSelection,
    NotificationRadiusSelection
  },
  data() {
    return {
      notificationItem: {
        due: "",
        unionmemberid: "",
        title: "",
        radius: 0
      }
    };
  },
  methods: {
    setNotificationDue(val) {
      this.notificationItem.due = val;
    },
    setUnionMemberId(val) {
      this.notificationItem.unionmemberid = val;
    },
    setNotificationRadius(val) {
      this.notificationItem.radius = val;
    },
    handleOk() {
      this.$emit("modal-ok", this.notificationItem);
    },
    handleClose() {
      this.$emit("modal-cancelled");
    }
  }
};
</script>

<style>
.md-form > input[type="date"]:not(.browser-default) + label {
  transform-origin: 0px 24px !important;
  transform: matrix(0.8, 0, 0, 0.8, 0, -14);
}
</style>
